import React, { useMemo, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { updatePaymentIntent, validatingPromoCode } from "../Services/Organisation.service";
import { Elements } from "@stripe/react-stripe-js";
import { Appearance, loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

const PaymentForm: React.FC<any> = (props) => {
  const isLive = props.isLive;
  const [tab, setTab] = useState(0);
  const [promoError, setPromoError] = useState<string | null>(null);

  const ValidatePromoCode = async () => {
    try {
      const data = await validatingPromoCode(props.values.promoCode, props.values.stripePaymentDetails.bookingId);
      if (data && data.data && data.data.length > 0) {
        props.setFieldValue("promoCodeValue", { promoCode: data.data[0] });
        // updatePaymentIntent({
        //   id:props.values?.stripePaymentDetails?.session?.id,

        // })
        setPromoError(null); // Clear any previous error
      } else {
        setPromoError("Invalid promo code");
      }
    } catch (err) {
      console.error(err, "error");
      setPromoError("Failed to validate promo code");
    }
  };


  useEffect(() => {
    if (props.values.promoCodeValue && props.values.TOTALAMOUNTWITHTDISCOUNT) {
      handleUpdatePaymentIntent({
        id: props.values?.stripePaymentDetails?.session?.id,
        originalAmount: props.values.TOTALAMOUNTWITHOUTDISCOUNT,
        discountAmount: Math.floor(props.values.TOTALAMOUNTWITHOUTDISCOUNT - props.values.TOTALAMOUNTWITHTDISCOUNT),
        bookingId: props.values?.stripePaymentDetails?.bookingId
      })
    }
  }, [props.values.promoCodeValue, props.values.TOTALAMOUNTWITHTDISCOUNT, props.values.TOTALAMOUNTWITHOUTDISCOUNT])


  const handleUpdatePaymentIntent = async (body: any) => {
    try {
      const response = await updatePaymentIntent(body, isLive)
      props.setFieldValue("stripePaymentDetails", { ...props.values.stripePaymentDetails, session: response.updatedIntents?.stripePaymentDetails?.session })
      props.setFieldValue("eurostripePaymentDetails", {
        ...props.values.eurostripePaymentDetails,
        session: response.updatedIntents?.
          euroPaymentDetails?.session
      })
      // if(response.session) {
      //   props.setFieldValue("stripePaymentDetails", {session: response.session})
      // }
    } catch (error) {
      console.log("asasassasa")
    }
  }

  const handleRemovePromoCode = async () => {
    props.setFieldValue("promoCode", null);
    props.setFieldValue("promoCodeValue", null);
    const data = await validatingPromoCode("", props.values.stripePaymentDetails.bookingId);
    handleUpdatePaymentIntent({
      id: props.values?.stripePaymentDetails?.session?.id,
      originalAmount: props.values.TOTALAMOUNTWITHOUTDISCOUNT,
      discountAmount: 0,
      bookingId: props.values?.stripePaymentDetails?.bookingId
    })
    setPromoError(null);
  };

  const pushDataToGTM = (details: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "bookingEvent",
      ...details,
    });
  };


  console.log(props.values)

  useEffect(() => {
    if (props?.values && window) {
      pushDataToGTM({
        event: "bookingEvent",
        email: props.values?.email,
        firstname: props?.values?.firstName,
        lastname: props?.values?.lastName,
        calendarname: props?.values?.calendarid,
        date: props?.values?.desiredDate,
      });
    }
  }, []);

  const stripePromise = useMemo(() =>
    loadStripe(
      isLive
        ? (process.env.REACT_APP_STRIPE_LIVE_KEY as string)
        : (process.env.REACT_APP_STRIPE_KEY as string)
    ), [isLive]);

  const appearance: Appearance = {
    theme: "stripe",
  };

  return (
    <Card variant="outlined" sx={{ margin: "auto" }} className="payment">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Payment Options {isLive && "(Live Mode)"}
        </Typography>

        {/* Promo Code Input */}
        <TextField
          fullWidth
          value={props.values.promoCode || ""}
          onChange={(e) => props.setFieldValue("promoCode", e.target.value)}
          label="Enter Promo Code / Gift Card Code / Store Credit"
          variant="outlined"
          margin="normal"
          disabled={props.values.promoCodeValue}
        />

        {/* Apply Button */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={!props.values.promoCode || props.values.promoCodeValue}
          onClick={ValidatePromoCode}
        >
          Apply
        </Button>

        {/* Show Applied Promo Code as Chip */}
        {props.values.promoCodeValue?.promoCode && (
          <Box mt={2}>
            <Chip
              label={`Applied: ${props.values.promoCodeValue.promoCode.name}`}
              color="info"
              onDelete={handleRemovePromoCode}
              variant="filled"
            />
          </Box>
        )}

        {/* Show error if promo code validation fails */}
        {promoError && (
          <Typography color="error" variant="body2" mt={1}>
            {promoError}
          </Typography>
        )}

        {/* Payment Mode Buttons */}
        <Box
          display="flex"
          justifyContent="space-between"
          gap="0.5rem"
          width="100%"
          marginTop="1.5rem"
          marginBottom="1.8rem"
        >
          <Button
            type="button"
            onClick={() => setTab(0)}
            variant={tab === 0 ? "contained" : "outlined"}
            fullWidth
          >
            CARD
          </Button>
          <Button
            type="button"
            onClick={() => setTab(1)}
            variant={tab === 1 ? "contained" : "outlined"}
            fullWidth
          >
            IDEAL
          </Button>
        </Box>

        {/* Loading State */}
        {!props.values.stripePaymentDetails &&
          !props.values.eurostripePaymentDetails && (
            <Box sx={{ width: "100%", marginTop: "0.8rem" }}>
              <LinearProgress />
            </Box>
          )}

        {/* Stripe Elements for Card Payment */}
        {props.values?.stripePaymentDetails?.session?.client_secret &&
          tab === 0 && (
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret: props.values.stripePaymentDetails.session.client_secret,
                appearance: appearance,
              }}
            >
              <CheckoutForm
                {...props}
                bookingId={props.values.stripePaymentDetails.bookingId}
                paymentIntentId={props.values.stripePaymentDetails?.session.id}
                isLive={isLive}
              />
            </Elements>
          )}

        {/* Stripe Elements for Ideal Payment */}
        {props.values?.eurostripePaymentDetails?.session?.client_secret &&
          tab === 1 && (
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret: props.values.eurostripePaymentDetails.session.client_secret,
                appearance: appearance,
              }}
            >
              <CheckoutForm
                {...props}
                bookingId={props.values.eurostripePaymentDetails.bookingId}
                addReturnUrl={true}
                paymentIntentId={props.values?.eurostripePaymentDetails?.session?.id}
                isLive={isLive}

              />
            </Elements>
          )}
      </CardContent>
    </Card>
  );
};

export default PaymentForm;
